import React from "react";
import { StickyFooter } from "./StickyFooter";
import { EventCardTag } from "./EventCardTag";
import { CalendarIcon, PinIcon } from "../icons";

import styles from "./event-sticky-footer.module.scss";
import { formatRange } from "@/helpers/formatRange";
import Button from "../Button/button";
import classNames from "classnames";

interface EventStickyFooterProps {
  title?: string;
  location?: string;
  startDate?: string;
  endDate?: string;
  soldOut?: boolean;
  paymentLink?: any;
  buttonText?: string;
  rightText?: string;
  buttonSize?: "small" | "medium" | "large";
  rightTextSize?: "small" | "medium" | "large";
  spacingRightTextButton?: "small" | "medium" | "large";
}

const EventStickyFooter = (props: EventStickyFooterProps) => {
  return (
    <StickyFooter>
      <div className={styles.wrapper}>
        <div className={styles.innerWrapper}>
          <div className={styles.overflowHidden}>
            <div className={styles.title}>{props.title}</div>
            <div className={styles.locationWrapper}>
              {props.location && (
                <EventCardTag
                  icon={<PinIcon variant="black" fill="white" size={16} />}
                  text={props.location}
                  variant="black"
                  className={styles.locationTag}
                />
              )}
              {props.startDate && props.endDate && (
                <EventCardTag
                  icon={<CalendarIcon variant="black" fill="white" size={16} />}
                  text={formatRange(
                    new Date(props.startDate),
                    new Date(props.endDate)
                  )}
                  variant="black"
                  className={styles.locationTag}
                />
              )}
            </div>
          </div>
          <div
            className={classNames("flex items-center", {
              [styles.gap2]: props.spacingRightTextButton === "small",
              [styles.gap4]:
                props.spacingRightTextButton === "medium" ||
                !props.spacingRightTextButton,
              [styles.gap8]: props.spacingRightTextButton === "large",
            })}
          >
            {props.rightText && (
              <span
                className={classNames(styles.colorWhite, {
                  [styles.mediumTextSize]: props.rightTextSize === "medium",
                  [styles.smallTextSize]: props.rightTextSize === "small",
                  [styles.largeTextSize]: props.rightTextSize === "large",
                })}
              >
                {props.rightText}
              </span>
            )}
            {props.soldOut ? (
              <Button
                btnStyle={"white"}
                accent_color={"border"}
                size={props.buttonSize}
              >
                SOLD OUT
              </Button>
            ) : (
              <Button
                btnStyle={"white"}
                accent_color={"border"}
                icon="IconArrowRight"
                lightIcon
                iconGap="none"
                link={props.paymentLink}
                size={props.buttonSize}
              >
                {props.buttonText || "Book now"}
              </Button>
            )}
          </div>
        </div>
      </div>
    </StickyFooter>
  );
};

export { EventStickyFooter };
